<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th class="col-sortable" (click)="toggleSort('productName')">
          <span translate>PRODUCT_NAME</span>
          <ng-container *ngIf="sortKey === 'productName'">
            <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-a-z ms-1"></i>
            <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-a-z ms-1"></i>
          </ng-container>
        </th>
        <th class="col-sortable" (click)="toggleSort('salesAmount')">
          <span translate>SALES_AMOUNT</span>
          <ng-container *ngIf="sortKey === 'salesAmount'">
            <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-1-9 ms-1"></i>
            <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-1-9 ms-1"></i>
          </ng-container>
        </th>
        <th class="col-sortable" (click)="toggleSort('quantity')">
          <span translate>QUANTITY</span>
          <ng-container *ngIf="sortKey === 'quantity'">
            <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-1-9 ms-1"></i>
            <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-1-9 ms-1"></i>
          </ng-container>
        </th>
        <th class="col-sortable" (click)="toggleSort('numberOfOrders')">
          <span translate>NUMBER_OF_ORDERS</span>
          <ng-container *ngIf="sortKey === 'numberOfOrders'">
            <i *ngIf="sortAsc" class="fa-solid fa-regular fa-arrow-up-1-9 ms-1"></i>
            <i *ngIf="!sortAsc" class="fa-solid fa-regular fa-arrow-down-1-9 ms-1"></i>
          </ng-container>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of sortedData">
        <td class="align-middle">
          <div>{{ element.productName }}</div>
          <div><small>{{ element.productId }}</small></div>
        </td>
        <td class="align-middle">
          {{ element.salesAmount == 0 ? '-' : (element.salesAmount | number : '1.0-2') }}
        </td>
        <td class="align-middle">
          {{ element.quantity == 0 ? '-' : (element.quantity | number : '1.0-2') }}
        </td>
        <td class="align-middle">
          {{ element.numberOfOrders == 0 ? '-' : (element.numberOfOrders | number : '1.0-2') }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
